<template>
  <div v-if="countriesData" class="">
    <div class="table-container">
      <table class="my-table">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("description") }}</th>
            <th>{{ $t("notes") }}</th>
            <th>{{ $t("info") }}</th>
            <th>{{ $t("edit") }}</th>
            <th>{{ $t("delete") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(Country, index) in countriesData" :key="index">
            <td>{{ ++index }}</td>
            <td>
              {{ isDataExist(Country.countryNameCurrent) }}
            </td>
            <td>
              {{ isDataExist(Country.countryDescriptionCurrent) }}
            </td>
            <td>{{ isDataExist(Country.countryNotes) }}</td>
            <td>
              <button
                v-b-modal.CountryInfo
                class="btn p-0"
                :title="$t('info')"
                @click="setCountryData(Country)"
              >
                <img src="@/assets/images/info.svg" class="icon-lg" />
              </button>
            </td>
            <td>
              <router-link
                :to="`/edit-country/${Country.countryToken}`"
                :title="$t('edit')"
              >
                <img src="@/assets/images/pencil.svg" class="icon-lg" />
              </router-link>
            </td>
            <td>
              <button
                v-b-modal.CountryDelete
                class="btn p-0"
                :title="$t('delete')"
                @click="setCountryData(Country)"
              >
                <img src="@/assets/images/trash.svg" class="icon-lg" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { setDataMultiLang, timeToLang, isDataExist } from "@/utils/functions";

export default {
  name: "CountriesTable",
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["countriesData", "countryData"],
  methods: {
    setCountryData(countryData) {
      this.$emit("setCountryData", countryData);
    },
    timeToLang(time) {
      return timeToLang(time, this.language);
    },
    setDataMultiLang(lang, dataAr, dataEn, dataUnd) {
      return setDataMultiLang(lang, dataAr, dataEn, dataUnd);
    },
    isDataExist(data) {
      return isDataExist(data);
    },
  },
  computed: {},
};
</script>

<style lang="scss"></style>
